import React from 'react';
import { MailIcon, InstagramIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-white/10 bg-ink" data-id="element-65" data-mp="3gfitaf6445cj">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" data-id="element-66" data-mp="3gh3sii3dgcgq">
        <p className="font-display text-xl font-black text-white" data-id="element-67" data-mp="32pfeuadh5fxn">
          CÓDIGO INFIDELIDAD<span className="align-super text-xs" data-id="element-68" data-mp="36q9354utwwr2">™</span>
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/60" data-id="element-69" data-mp="3ufa7afwmplqj">
          El protocolo de emergencia emocional N°1 para personas que descubrieron una infidelidad.
          Porque atravesar esto sin un sistema no debería costarte la salud mental ni la dignidad.
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-70" data-mp="3qd6sbhar3z0i">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors hover:text-rojo-soft" data-id="element-71" data-mp="29ynjtg85axbw">
            <MailIcon className="h-4 w-4 text-plata" data-id="element-72" data-mp="3l9k6xg5ljtev" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-rojo-soft" data-id="element-73" data-mp="3gagzjp259b3q">
            <InstagramIcon className="h-4 w-4 text-plata" data-id="element-74" data-mp="3v8rgds97n3wp" /> @sigmasmartoficial
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors hover:text-rojo-soft" data-id="element-75" data-mp="3q8dhp0ti16bc">
            <GlobeIcon className="h-4 w-4 text-plata" data-id="element-76" data-mp="8178js5jp0n7" /> www.sigmasmart.store
          </a>
        </div>

        <p className="mt-4 font-display text-base italic text-plata" style={{
        fontWeight: "600",
        color: "#FF5A68"
      }} data-id="element-77" data-mp="31uo1e25c5ns">
          🔍 “Tomá el control, recuperá tu poder.” 🛡️
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/40" data-id="element-78" data-mp="cuiku8t4m9mi">
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-79" data-mp="qtrpqcbvthb6">
            Términos y condiciones
          </a>
          <span data-id="element-80" data-mp="mq3hrsjc8jpe">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-81" data-mp="tvmr3jy8gkmy">
            Política de privacidad
          </a>
          <span data-id="element-82" data-mp="yv94puhz42wa">·</span>
          <a href="#" className="transition-colors hover:text-white/70" data-id="element-83" data-mp="yupoci7z1mkd">
            Soporte
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/35" data-id="element-84" data-mp="13rg04tcqtvzz">
          © 2026 CÓDIGO INFIDELIDAD™ — SIGMA SMART™ — Todos los derechos reservados. Prohibida la
          reproducción y redistribución sin autorización expresa.
        </p>
      </div>
    </footer>;
}